import React from "react";
import { useRouteError, Link } from "react-router-dom";
import { motion } from "framer-motion";

const ErrorPage = () => {
  const error = useRouteError();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white text-center px-6">
      <motion.h1
        className="text-5xl font-extrabold text-blue-700 mb-4"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Page Under Construction
      </motion.h1>

      <motion.p
        className="text-gray-600 text-lg max-w-xl mx-auto mb-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        🏗️ We’re updating this page with new listings and details.
        Please check back soon — your dream property is on the way!
      </motion.p>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.6 }}
      >
        <Link
          to="/"
          className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition"
        >
          Back to Home
        </Link>
      </motion.div>

      {error && (
        <p className="text-gray-400 text-sm mt-4">
          {error.statusText || error.message}
        </p>
      )}
    </div>
  );
};

export default ErrorPage;
